import { render, staticRenderFns } from "./SendMessageHistory.vue?vue&type=template&id=59ca6cb6&scoped=true&lang=pug"
import script from "./SendMessageHistory.vue?vue&type=script&lang=ts"
export * from "./SendMessageHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageHistory.vue?vue&type=style&index=0&id=59ca6cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca6cb6",
  null
  
)

export default component.exports